import axios from "axios";

export const getCitas = ({ clinica, from, to }) => {
  const params = { from, to };
  if (clinica !== "ALL") params.clinica = clinica;

  return axios.get("/api/citas", {
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }).then(r => r.data);
};

export const crearCita = async (cita) => {
  const { data } = await axios.post("/api/citas", cita, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  });
  return data;
};

export const actualizarCita = (id, cita) => {
  return axios.put(`/api/citas/${id}`, cita, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }).then(r => r.data);
};

export const eliminarCita = (id) => {
  return axios.delete(`/api/citas/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  });
};

